package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable

@Serializable
data class Certificate(
    val name: String,
    val date: String,
    val description: String
)